module.exports = __webpack_public_path__ + "media/components/country-flag/static/mx-98bb54869a3265efb8b3f2f06c879a99.svg";